<template>
  <div class="c-page-turner">
    <div
      class="library"
      :class="{ active: $route.path === $paths.library }"
      @click="onItemClick($paths.library)"
    >
      <div class="arrow">
        <i class="iconfont iconarrow-left" />
      </div>
      <div class="number">
        01
      </div>
      <div class="title" v-html="$t('pageTurner.library')"></div>
    </div>
    <div
      class="publish"
      :class="{ active: $route.path === $paths.publish }"
      @click="onItemClick($paths.publish)"
    >
      <div class="arrow">
        <i class="iconfont iconarrow-right" />
      </div>
      <div class="number">
        02
      </div>
      <div class="title" v-html="$t('pageTurner.publish')"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CPageTurner",
  data() {
    return {};
  },
  methods: {
    onItemClick(path) {
      this.$router.push(path);
    },
  },
};
</script>
<style lang="scss" scoped>
.c-page-turner {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: 1000;

  .library,
  .publish {
    display: flex;
    align-items: flex-start;
    cursor: pointer;

    .arrow {
      @include flex-center;
      width: 64px;
      height: 64px;
      background: $primary-color;
      border-radius: 10px;
      color: #ffffff;
      margin-right: 30px;
      visibility: hidden;

      i {
        font-size: 30px;
      }
    }

    .number {
      line-height: 64px;
      color: #ffffff;
      font-size: 40px;
      font-weight: bold;
      margin-right: 10px;
    }

    .title {
      width: 200px;
      font-size: 12px;
      color: #ffffff;
      line-height: 20px;
      padding: 12px 0 20px 0;
      border-bottom: 1px solid #ffffff;
    }

    &:hover {
      .arrow {
        visibility: visible;
      }

      .title {
        border-color: $primary-color;
      }
    }

    &.active {
      .title {
        border-color: $primary-color;
      }
    }
  }

  .library {
    margin-bottom: 110px;
  }
}
</style>
